import { SystemText } from 'e4shared';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import BlobImage from 'components/blobImage';
import { Header as PrismHeader } from 'components/prism/header';

export const PageHeader = props => {
    const { title, metaTitle, useProfile, extra, after, overrideProfile, testId } = props;

    const { user } = useSelector(state => state.user);
    const { profile } = useSelector(state => state.profile);

    const profileToUse = overrideProfile || profile;
    const subTitle = profileToUse && profileToUse.id !== user.id ? profileToUse.full_Name : '';

    document.title = `Richardson | ${subTitle ? `${subTitle} - ` : ''}${title || metaTitle}`;

    if (user?.companySettings?.prism_UI) {
        return <PrismHeader {...props} />;
    }

    return (
        <section data-testid={testId} className="content-header">
            <div className="title-details flex flex-center">
                {(profileToUse || (user && !useProfile)) && (
                    <div className="title-user-image hidden-xs hidden-sm">
                        <BlobImage
                            folder="avatar"
                            initials={user.initials}
                            key={profileToUse && profileToUse?.id !== user.id ? profileToUse.avatar : user.avatar}
                            src={profileToUse && profileToUse?.id !== user.id ? profileToUse.avatar : user.avatar}
                            className="img-circle"
                        />
                    </div>
                )}
                <div className="title-text">
                    <h1 id="title">
                        <div className="flex">
                            <div>{title}</div>
                            {after && <div className="title-after ml10">{after()}</div>}
                        </div>
                        {profileToUse && profileToUse.id !== user.id && (
                            <span className="mt5 text-smx">
                                {subTitle}
                                {profileToUse.id && !profileToUse.active
                                    ? ` - ${SystemText('General/Controls/PageHeader/Inactive')}`
                                    : ''}
                            </span>
                        )}
                    </h1>
                </div>
                {extra && <div className="title-extra hidden-xs">{extra()}</div>}
            </div>
            {extra && <div className="title-extra-xs visible-xs">{extra()}</div>}
        </section>
    );
};

export default withRouter(PageHeader);
